// extracted by mini-css-extract-plugin
export default {"wrapper":"Footer_wrapper__q2Lqj","container":"Footer_container__aLu0c","content":"Footer_content__0ToZM","list":"Footer_list__WRIO7","item":"Footer_item__Ii0zw"};